import { CashDetail } from "../CashDetail";
import { Denomination } from "../Denomination";
import { CashTypeEnum } from "../enums/CashTypeEnum";

export class CoinRollsConfigurationContainer {
    coinRollsConfiguration: CoinRollsConfiguration[] = [];

    getByDen(model: string, d: Denomination): CashDetail {
        return this.coinRollsConfiguration.find((c) => c.model === model && c.denomination.isEquals(d));
    }

    // isRoll(src: CashDetail): boolean {
    //     var config = this.coinRollsConfiguration.find((c) => c.denomination.isEquals(src.denomination));
    //     return config && src.quantity % config.quantity == 0;
    // }

    // getRollsQuantity(src: CashDetail): string {
    //     var config = this.coinRollsConfiguration.find((c) => c.denomination.isEquals(src.denomination));
    //     if (config && src.quantity % config.quantity == 0) {
    //         return src.quantity / config.quantity + " (x " + config.quantity + ")";
    //     }

    //     return src.quantity;
    // }

    // getSingleRollValue(src: CashDetail): number {
    //     var config = this.coinRollsConfiguration.find((c) => c.denomination.isEquals(src.denomination));
    //     if (config && src.quantity % config.quantity == 0) {
    //         return config.quantity * config.denomination.value;
    //     }

    //     return 0;
    // }

    static parse(data: any[]) {
        var res = new CoinRollsConfigurationContainer();
        data.forEach((c) => {
            var crc = new CoinRollsConfiguration();

            const den = new Denomination();
            den.currency = c.Currency;
            den.revision = c.Revision;
            den.value = c.Value;
            den.type = CashTypeEnum.Coin;

            crc.denomination = den;
            crc.quantity = c.Quantity;
            crc.model = c.Model;
            res.coinRollsConfiguration.push(crc);
        });
        // console.log("res", res);
        return res;
    }
}

export class CoinRollsConfiguration extends CashDetail {
    model: string;
}
